import styled from "styled-components";
export const NameView = styled.div `
	font-size: 14px;
	color: #333333;
	font-weight: normal;
	line-height: 19px;
	height: 38px;
	:hover {
		color: #cb2027;
	}
`;
export const OneLineName = styled.p `
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
export const TwoLineName = styled.p `
	height: inherit;
	word-break: break-all;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
`;
export const ActiveImg = styled.img `
	margin-top: 5px;
	height: 16px;
	margin-bottom: 3px;
`;
